<!-- Responsibility: Render scene HUD vitals and quick action chips.
Scope: Visual/action rail only; no dialog ownership or player-sheet routing. -->
<scene-action-rail>
  <output if={ props.view?.processing } role="status" aria-live="polite">
    { props.view?.processingText }
  </output>

  <section
    if={ props.view?.showHud }
    data-expanded={ props.view?.expanded ? 'true' : 'false' }
    onpointerdown={ props.actions?.expandHud }
    onclick={ props.actions?.expandHud }
    onfocusin={ props.actions?.expandHud }
    onfocusout={ onFocusOut }
    ontouchstart={ onTouchStart }
    ontouchend={ onTouchEnd }
  >
    <header if={ props.view?.playerVitals } aria-label="Vitals">
      <button
        each={ vital in vitalEntries() }
        type="button"
        class="tooltip-wrap"
        data-vital={ vital.key }
        data-tone={ vital.tone }
        aria-label={ vital.aria }
        onclick={ () => props.actions?.openVitalModal?.(vital.key) }
        onkeydown={ (e) => props.actions?.onActivateKey?.(e, () => props.actions?.openVitalModal?.(vital.key)) }
      >
        { vital.symbol } { vital.value }
        <div class="tooltip" data-position="bottom" data-tip-custom="true">
          <b>{ vital.key.toUpperCase() }</b><br/>
          { vital.tip }
        </div>
      </button>
    </header>

    <nav if={ props.view?.showQuickTop } aria-label="Quick actions">
      <ul if={ props.view?.quickAbilities?.length } data-group="abilities">
        <li each={ ability in props.view.quickAbilities }>
          <button
            type="button"
            class="tooltip-wrap"
            data-cooldown={ ability.onCooldown ? 'true' : 'false' }
            onclick={ () => props.actions?.openAbilityModal?.(ability) }
          >
            ✦ { ability.name }
            <div class="tooltip" data-position="bottom" data-tip-custom="true">
              <raw-html content={ props.actions?.abilityHoverText?.(ability) } />
            </div>
          </button>
        </li>
      </ul>
      <ul if={ props.view?.quickExitActions?.length } data-group="exits">
        <li each={ exitAction in props.view.quickExitActions }>
          <button
            type="button"
            class="tooltip-wrap"
            data-entry="exit"
            data-style={ exitAction.style }
            onclick={ () => props.actions?.useExitAction?.(exitAction) }
          >
            { exitAction.label }
            <div class="tooltip" data-position="bottom" data-tip-custom="true">
              { exitAction.hint }
            </div>
          </button>
        </li>
      </ul>
    </nav>

    <action-input if={ props.view?.interactive }></action-input>
  </section>

  <script>
    import ActionInput from './action-input.riot'
    import { describeVital } from '../../engine/vitals'

    export default {
      components: { ActionInput },
      startY: null,

      onTouchStart(e) {
        const touch = e && e.changedTouches && e.changedTouches[0]
        if (!touch) return
        this.startY = touch.screenY
      },

      onTouchEnd(e) {
        const touch = e && e.changedTouches && e.changedTouches[0]
        if (this.startY == null || !touch) return
        const diff = touch.screenY - this.startY
        this.startY = null
        const actions = this.props.actions || {}
        if (diff < -30) {
          actions.expandHud && actions.expandHud()
        } else if (diff > 30) {
          actions.collapseHud && actions.collapseHud()
        }
      },

      onFocusOut(event) {
        const nextTarget = event?.relatedTarget
        const hud = this.$('section')
        if (nextTarget instanceof Element && hud?.contains?.(nextTarget)) return
        this.props.actions?.collapseHud?.()
      },

      vitalText(key) {
        return describeVital(this.props.view?.playerVitals ?? {}, key).label
      },

      vitalTone(key) {
        return describeVital(this.props.view?.playerVitals ?? {}, key).tone
      },

      vitalEntries() {
        return [
          {
            key: 'vitality',
            symbol: '❤',
            value: this.vitalText('vitality'),
            tone: this.vitalTone('vitality'),
            tip: 'Vitality. Physical health and injury tolerance.',
            aria: `Vitality: ${this.vitalText('vitality')}`,
          },
          {
            key: 'spirit',
            symbol: '✦',
            value: this.vitalText('spirit'),
            tone: 'mid',
            tip: 'Spirit. Mental focus and willpower reserves.',
            aria: `Spirit: ${this.vitalText('spirit')}`,
          },
          {
            key: 'essence',
            symbol: '✿',
            value: this.vitalText('essence'),
            tone: 'mid',
            tip: 'Essence. Life force and magical potential.',
            aria: `Essence: ${this.vitalText('essence')}`,
          },
        ]
      },
    }
  </script>
</scene-action-rail>
